<template>
  <v-navigation-drawer
    v-model="drawerChild"
    :mini-variant="false"
    width="250"
    clipped
    app
    
    style="box-shadow: 2px -4px 5px 0px rgba(0,0,0,0.85);background-color:#171717"
    floating
  >
    <v-list >
      <template>
        <v-list-tile @click="promptImg">
          <input v-show="false" type="file" id="input-file" @change="goPreview" accept="image/*" multiple>
          <v-list-tile-action>
            <hexagon gradient />
            <ittention class="hexagon_icon_ittention"></ittention>  
          </v-list-tile-action>
          <v-list-tile-content>
            <trapez gradient/>
            <v-list-tile-title class="subheading ml-2" style="color:black">{{$t('titles.addMedias')}}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile @click="switchNameMethod('dialog')">
          <v-list-tile-action>
            <hexagon outline/>
            <v-icon class="hexagon_icon" :color="items[1].color">{{items[1].icon}}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="subheading ml-2">{{$t('titles.newProject')}}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-group @click="projectRoute = false" no-action :value="projectRoute" key="Projects">
          <directoriesVue/>
          <v-list-tile slot="activator" id="element">
            <v-list-tile-action id="test">
              <hexagon outline/>
              <v-icon class="hexagon_icon" color="#77edaf">fa-folder-open</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title class="subheading ml-2">{{$t('titles.myProjects')}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>
        <!-- <v-list-tile @click="switchNameMethod(items[2].action)">
          <v-list-tile-action>
            <hexagon outline/>
            <v-icon class="hexagon_icon" :color="items[2].color">{{items[2].icon}}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="subheading ml-2">{{items[2].title}}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile> -->
      </template>
    </v-list>
    <modal-newimage-vue/>
  </v-navigation-drawer>
</template>


<script>
import directoriesVue from "../directories/directories.vue";
import hexagon from "../icons/hexagon.vue";
import trapez from "../icons/trapez.vue";
import ittention from "../icons/ittention-logo.vue";
import modalNewimageVue from "../modals-form/modal-newimage.vue";

export default {
  name: "navigation",
  props: ["drawer", "items"],
  components: {
    directoriesVue,
    hexagon,
    trapez,
    modalNewimageVue,
    ittention
  },
  data() {
    return {
      imageData: [],
      drawerChild: true,
      itemList: [],
      mini: true,
      dialog: false,
      projectRoute: false
    };
  },
  created() {
    let routeName = this.$router.currentRoute.name;
    if (routeName === "projectsimple")
      this.projectRoute = true;
  },
  mounted() {
    this.itemList = this.items;
  },
  computed: {
  },
  methods: {
    promptImg() {
      this.$store.commit("image/emptyMultiSelectImg");
      const inputFile = document.getElementById("input-file");
      inputFile.click();
    },
    async goPreview(event) {
      let input = event.target;
      let imageDatas = [];
      // Ensure that you have a file before attempting to read it
      if (!input.files || !input.files[0]) 
        return;
      // create a new FileReader to read this image and convert to base64 format
      // Define a callback function to run, when FileReader finishes its job
      let files = input.files;
      
      for (let i = 0; i < files.length; i++) {
        imageDatas.push(files[i]);
      }
      let badImgs = imageDatas.map(async (img, index) => {
        if (img.type !== 'image/png' && img.type !== 'image/jpg' && img.type !== 'image/jpeg') {
          let imgToDel = img;
          return new Promise(res => setTimeout(() => {
            imageDatas.splice(imageDatas.indexOf(imgToDel), 1);
            res();
          }, 100));
        } return null;
      });
      badImgs = await Promise.all(badImgs)
      if (badImgs.filter(el => el !== null).length > 0)
        this.$store.commit('dialogModal/showNotif', [this.$t('titles.badImg'), this.$t('texts.badImg')]);
      imageDatas.forEach((img, index) => {
        
        let reader = new FileReader();
        let imageObject = new Image();
        reader.onload = e => {
          // Note: arrow function used here, so that "imageDatas" datarefers to the imageData of Vue component
          // Read image as base64 and set to imageData
          img.src = e.target.result;
          // this.$refs["image" + parseInt(index)][0].src = img.src;
          imageObject.src = img.src;
          let app = this;
          imageObject.onload = function(e) {
            img.width = this.width;
            img.height = this.height;
          };
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(img);
      });
    


      this.$store.dispatch('image/savePreviews', imageDatas);
      imageDatas = [];
      this.$router.push('/preview');
    },
    logout() {
      this.$store.dispatch("authentication/logout");
    },
    toggleMiniDrawer() {
      this.mini = !this.mini;
    },

    switchNameMethod(nameMethod) {
      let element_actives;
      switch (nameMethod) {
        case "logout":
          this.logout();
          break;
        case "toggleMiniDrawer":
          this.toggleMiniDrawer();
          element_actives = document.getElementsByClassName(
            "v-list__group__items v-list__group__items--no-action"
          )[0];
          if (element_actives.style.display != "none" && this.mini) {
            let btn = document.getElementsByClassName(
              "v-list__group__header__append-icon"
            )[0];
            btn.click();
            this.toggleMiniDrawer();
            this.toggleMiniDrawer();
          }
          break;
        case "dialog":
          this.$store.dispatch("dialogModal/toggle");
          break;
        // case "add_media":
        //   this.$store.dispatch("dialogModal/toggleModalImg");
        //   break;
        case "reports":
          this.$router.push("/reports");
          break;
        case "folders":
          if (this.mini) {
            this.toggleMiniDrawer();
          }
          // this.$router.push("/projects");
          break;
        case "images":
          this.$router.push("/medias");
          break;
        case "home":
          this.$router.push("/home");
          break;
        case "me":
          this.$router.push("/user");
          break;
        case "selection":
          this.$router.push("/selection");
          break;
        case "go_back":
          this.$router.go(-1);
          break;
        case "design":
          this.$router.push("/design");
          break;
        case "reportsaoi":
          this.$router.push("/reports-aoi");
        default:
          break;
      }
    }
  },
  watch: {
    $route() {
      let routeName = this.$router.currentRoute.name;
      if (routeName === "projectsimple")
        this.projectRoute = true;
    },
  }
};
</script>

<style>
.hexagon_icon {
  z-index: 1;
  position: absolute;
  top: 11px;
  left: 32px;
  fill: red !important;
}

.v-list__tile:hover .hexagon_svg {
  fill: #305584 !important;
}
.v-list__tile:hover .hexagon_icon {
  fill: #305584 !important;
}
.v-list__tile:hover .trapez_path {
  fill: #305584 !important;
}

.module_card {
  box-shadow: 6px 4px 15px 2px rgba(0, 0, 0, 0.85);
  border-radius: 4px;
}
.v-icon {
  transition: 0.3s !important;
  /* transition-delay: 0s!important; */
}

.v-list__group__header__append-icon {
  display: none;
}
aside .subheading:not(.all-proj) {
  text-transform: uppercase;
}

</style>
